import { Component, OnInit, isDevMode } from '@angular/core';
import { SliderStepComponent } from '../../step/slider-step/slider-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-estimated-down-payment',
  templateUrl: './estimated-down-payment.component.html',
  styleUrls: ['./estimated-down-payment.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class EstimatedDownPaymentComponent extends SliderStepComponent implements OnInit {

  public loanAmount;
  lastSliderValue?:number;
  title = 'Estimated down payment';

  ngOnInit() {
    this.sliderValue = 1;
    this.sliderValues = [0, 3.5, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 5];
    this.sliderLabels = ['0% Down', '3.5% Down', '5% Down', '10% Down', '15% Down', '20% Down', '25% Down', '30% Down', '35% Down',
      '40% Down', '45% Down', '50% Down', '55% Down', '60% Down', '65% Down', '70% Down', '75% Down', '80% Down', '85% Down', '90% Down',
      '95% Down', 'Other'];
    this.sliderDisplay = this.sliderLabels[this.sliderValue];
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('estimatedDownPayment', this.control);
  }

  slide(e) {

    this.lastSliderValue = e.target.value;
    //Custom slide to implement displaying loan amount as a $
    this.sliderValue = e.target.value;
    this.sliderDisplay = this.sliderLabels[e.target.value];

    this.loanAmount = this.sliderValue != this.sliderValues.length - 1
      ? this.downPayment(e.target.value) //'About $' + Math.round((this.form.controls.newHomeValue.value * this.sliderValues[e.target.value] / 100)).toLocaleString()
      : '';

    //ab test downPaymentChangesJumboLoans
    if (this.form.controls.newHomeValue.value >= 647000) {
      if (this.sliderValue < 3) {
        this.control.setErrors({
          'incorrect': true,
          'message': 'Jumbo Loans require a minimum down payment of 10%, except for VA Loans.',
        });
      } else {
        this.control.setErrors(null);
      }
    }
  }

  initStep() {
    //ab test downPaymentChangesJumboLoans
    this.control.setErrors(null);

    if (!this.lastSliderValue) {
      this.sliderValue = (this.form.controls.newHomeValue.value >= 647000) ? 3 : 1;
      this.sliderDisplay = this.sliderLabels[this.sliderValue];
    }

    this.loanAmount = this.downPayment(this.sliderValue); //'About $' + (this.form.controls.newHomeValue.value * this.sliderValues[this.sliderValue] / 100).toLocaleString();
  }

  redirectTables(value: string): boolean {
    // Redirect if this will be LL
    if (this.form.controls.desiredLoanAmount.value <= 99000) {
      if (isDevMode()) {
        console.log('purchase LL redirect');
      }
      return true;
    }

    return false;
  }

  countVisitorAction() {
    this.form.controls.estimatedDownPaymentAction.setValue('1');
  }

  protected downPayment(index: number) {
    let newHomeValue = this.form.controls.newHomeValue.value;
    if (newHomeValue >= 1000000) {
      let intValue = Math.floor((newHomeValue * this.sliderValues[index] / 100));
      return 'About $' + (Math.floor(intValue/5000)*5000).toLocaleString();
    } else {
      let intValue = Math.floor((newHomeValue * this.sliderValues[index] / 100));
      return 'About $' + (Math.floor(intValue/1000)*1000).toLocaleString();
    }
  }

}
